const EMPTY_TOOTH = ['--', '--', '--', '--']

const TOOTH_PART_PATTERN = /^(?:--|[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*(?:,[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*)*)?$/

export const parseToothRows = (value: unknown): string[][] => {
  const rawValue = typeof value === 'string' ? value : ''
  const rows = rawValue.indexOf('@') >= 0
    ? rawValue.split('#')
    : [`${rawValue}@--@--@--`]

  const isValid = rows.length > 0 && rows.every((row) => {
    const parts = row.split('@')
    return parts.length === 4 && parts.every((part) => TOOTH_PART_PATTERN.test(part))
  })

  if (!isValid) {
    return [EMPTY_TOOTH.map(() => '')]
  }

  return rows.map((row) =>
    row.split('@').map((part) => (part === '--' ? '' : part))
  )
}

